import { Component, OnInit, ViewChild } from "@angular/core"
import { Router } from "@angular/router"
import { CHNode } from "../../../models/node.model"
import { BrowsingService } from "../../../services/browsing.service"
import { LocalizationService } from "../../../services/localization.service"
import { EduComponent } from "../../../utils/eduComponent"
import { SubjectsDropdownComponent } from "../subjects-dropdown/subjects-dropdown.component"
import { GradesDropdownComponent } from "../grades-dropdown/grades-dropdown.component"
import { GRADE_BANDS } from "../../../models/constants"
import { UserService } from "../../../services/user.service"

@Component({
    selector: "app-main-navigation",
    templateUrl: "./main-navigation.component.html",
    styleUrls: ["./main-navigation.component.scss"],
})
export class MainNavigationComponent extends EduComponent implements OnInit {
    @ViewChild(SubjectsDropdownComponent) subjectsDropdown: SubjectsDropdownComponent
    @ViewChild(GradesDropdownComponent) gradesDropdown: GradesDropdownComponent

    gtmPrefix: string = "gtm-navigation-"
    gradeBands = GRADE_BANDS
    subjects: CHNode[]
    stateName: string = null

    constructor(
        private browsingService: BrowsingService,
        private localizationService: LocalizationService,
        public router: Router,
        private userService: UserService
    ) {
        super()
    }

    public getAvailableSubjects(discipline) {
        return discipline.children.filter((node) => node.resultsCount > 0)
    }

    public openStudentExperienceInNewTab() {
        this.userService.switchUserExperience(true, "_blank")
    }

    public ngOnInit() {
        this.addSub(
            this.browsingService.getSubjectsTree().subscribe(
                (data: CHNode[]) => {
                    this.subjects = data
                },
                (error) => console.error(`[CUSTOM Error]${error}`)
            )
        )

        this.addSub(
            this.localizationService.localizeData.subscribe((response) => {
                if (response && response.stateName) {
                    this.stateName = response.stateName
                } else {
                    this.stateName = null
                }
            })
        )
    }

    navigateTo(url: string[]): void {
        this.router.navigate(url)
    }

    onTogglePanel(panelName: string) {
        panelName === "subject"
            ? (this.gradesDropdown.isGradesPanelOpened = false)
            : (this.subjectsDropdown.isSubjectsPanelOpened = false)
    }
}
